import type { ReceiptTemplate } from '../schema';

export const circleKTemplate: ReceiptTemplate = {
  id: 'circle-k',
  name: 'Circle K Receipt',
  brand: 'CIRCLE K',
  description: 'Circle K convenience store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ck-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/circle-k.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ck-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ck-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'POLAR POP 44OZ', quantity: '1', price: '0.99', sku: '' },
          { id: '2', name: 'SNICKERS BAR', quantity: '1', price: '1.99', sku: '' },
          { id: '3', name: 'CHIPS DORITOS', quantity: '1', price: '2.49', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ck-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '5.47', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.45', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '5.92', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ck-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'CASH',
        fields: [
          { id: 'tend', label: 'CASH:', value: '10.00' },
          { id: 'change', label: 'CHANGE:', value: '4.08' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ck-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'EASY REWARDS MEMBER\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

